import React from "react";
import Label from "../../UI/Label/Label";
import { getPortalNameForEligibilityScreen } from "../../shared/utility";
import classes from "./MemberPortalInfo.css";
import Moment from "moment";
import { CAREADVISORCONNECT } from "../../shared/Constants";

export const memberPortalInfo = (props) => {
  let dob = props.memberData.mdmDob
    ? props.memberData.mdmDob
    : props.memberData.essoData.dob;
  dob = dob ? Moment(dob).format("YYYY-MM-DD") : "";

  return (
    <div className={classes.MbrPrtlInfo}>
      <React.Fragment>
        <div className={classes.MbrPrtlInfoLeft}>
          <h2>ID Details</h2>
          <Label
            labelText="First Name: "
            labelValue={
              props.isNullHSID
                ? props.memberData.mdmFirstNm
                : props.memberData.essoData &&
                  props.memberData.essoData.firstName
            }
            displayType="horizontal"
          />
          <Label
            labelText="Last Name: "
            labelValue={
              props.isNullHSID
                ? props.memberData.mdmLastNm
                : props.memberData.essoData &&
                  props.memberData.essoData.lastName
            }
            displayType="horizontal"
          />
          <Label
            labelText="Date of Birth: "
            labelValue={dob}
            displayType="horizontal"
          />
          <Label
            labelText="Zip Code: "
            labelValue={props.memberData.mdmZip}
            displayType="horizontal"
          />
        </div>
        <div className={classes.MbrPrtlInfoRight}>
          <h2>
            {getPortalNameForEligibilityScreen(
              props.mbrPortalInfo.portalShortNm,
              props.portals
            )}{" "}
            {props.mbrPortalInfo.portalShortNm === CAREADVISORCONNECT ?"Details":"Portal Details"}
          </h2>
          <Label
            labelText="First Name: "
            labelValue={props.mbrPortalInfo.portalFirstNm}
            displayType="horizontal"
          />
          <Label
            labelText="Last Name: "
            labelValue={props.mbrPortalInfo.portalLastNm}
            displayType="horizontal"
          />
          <Label
            labelText="Date of Birth: "
            labelValue={props.mbrPortalInfo.portalDob}
            displayType="horizontal"
          />
          <Label
            labelText={
              props.mbrPortalInfo.portalShortNm === "CAP"
                ? "FARO ID: "
                : "Subscriber ID: "
            }
            labelValue={props.mbrPortalInfo.portalSubscriberId}
            displayType="horizontal"
          />
          <Label
            labelText="Member ID: "
            labelValue={props.mbrPortalInfo.portalSpecificMemberId}
            displayType="horizontal"
          />
          <Label
            labelText="Policy Number: "
            labelValue={props.mbrPortalInfo.portalPolicyNbr}
            displayType="horizontal"
          />
          <Label
            labelText="Gender: "
            labelValue={
              props.mbrPortalInfo.portalGender
                ? props.mbrPortalInfo.portalGender
                : "-"
            }
            displayType="horizontal"
          />
          <Label
            labelText="State: "
            labelValue={
              props.mbrPortalInfo.portalState
                ? props.mbrPortalInfo.portalState
                : "-"
            }
            displayType="horizontal"
          />
          <Label
            labelText="Zip Code: "
            labelValue={
              props.mbrPortalInfo.portalZip
                ? props.mbrPortalInfo.portalZip
                : "-"
            }
            displayType="horizontal"
          />
        </div>
      </React.Fragment>
    </div>
  );
};

export default memberPortalInfo;
